import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const PaddockWrap = styled.div`
  height: 500px;
  overflow: auto;
  .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    &:hover{
      opacity: 0.8;
    }
  }
  .confirm-delete-plan .ant-btn-primary{
    background: #0B2A1B;
  }
  .btn-edit-paddock{
    border:none;
    color: #0B2A1B;
  } 
  .ant-popover-buttons .ant-btn-sm{
    background: #0B2A1B;
  }
  .btn-delete-paddock{
    border:none;
    color: red;
  }
  .card_content{
    display:inline;
  }

  .card_value{
    float:right;
  }
`;

export default WithDirection(PaddockWrap);